import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { ALL_DAY } from '../../../../../constants/restaurantConst';
import MediaViewer from '../../../../../shared/media-viewer/MediaViewer';
import { IN_ROOM_DINING_CATEGORY_DAYS } from '../../../../../constants/InRoomDiningConst';

const CategoryViewDetails = ({ tabValue, category }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedDays, setSelectedDays] = useState([]);

  useEffect(() => {
    setSelectedCategory(category);
    const daysToMap = formatArrayForDisplay(category.hours.timings);
    setSelectedDays(daysToMap);
  }, [category]);

  const formatArrayForDisplay = (selectedDays) => {
    const daysToReturn = [];
    let daysList = [...selectedDays];
    while (daysList.length > 0) {
      const firstObject = daysList[0];
      const filteredRows = daysList.filter(
        (dayKey) => dayKey.from === firstObject.from && dayKey.to === firstObject.to,
      );
      daysToReturn.push({
        days: filteredRows.map((filteredRowDaysName) => filteredRowDaysName.day),
        from: filteredRows[0].from,
        to: filteredRows[0].to,
      });

      const tempDaysList = [...daysList];
      filteredRows.forEach((filteredRowsItem) => {
        const findFilteredDayIndex = tempDaysList.findIndex(
          (tempDaysListItem) => tempDaysListItem.day === filteredRowsItem.day,
        );
        tempDaysList.splice(findFilteredDayIndex, 1);
      });
      daysList = [...tempDaysList];
    }
    return daysToReturn;
  };

  const daysConteniousCheck = (days) => {
    const firstIndex = IN_ROOM_DINING_CATEGORY_DAYS.findIndex(
      (day) => day.name.toLowerCase() === days[0].toLowerCase(),
    );
    for (let i = 0; i < days.length; i++) {
      if (
        days[i].toLowerCase() !==
        IN_ROOM_DINING_CATEGORY_DAYS[(i + firstIndex) % 7].name.toLowerCase()
      )
        return false;
    }
    return true;
  };

  const renderDays = (days) => {
    if (days.length > 2) {
      const areDaysContenious = daysConteniousCheck(days);
      if (areDaysContenious) {
        const tempdays = [days[0], days[days.length - 1]];
        return tempdays
          .map((tempDay) => tempDay.charAt(0).toUpperCase() + tempDay.slice(1, 3).toLowerCase())
          .join(' to ');
      }
      return days
        .map((day) => {
          if (day === 'EVERYDAY') return 'Everyday';
          return day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase();
        })
        .join(', ');
    } else {
      return days[0] === 'EVERYDAY'
        ? 'Everyday'
        : days.map((day) => day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase()).join(', ');
    }
  };

  const changeTimeFormat = (from, to) => {
    return `${moment(from, 'HH:mm').format('LT')} - ${moment(to, 'HH:mm').format('LT')}`;
  };

  return (
    <div className='row mx-4 mt-4'>
      {tabValue === 0 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Category Name</div>
            <div className='details-value preview-breaks'>{selectedCategory?.name}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label text-center'>Status</div>
            <div
              className={`${
                selectedCategory?.status ? 'pill-active' : 'pill-inactive'
              } col-md-3 pill-text pill container`}
            >
              <span>{selectedCategory?.status ? 'Active' : 'Inactive'}</span>
            </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Category Code</div>
            <div className='details-value'>{selectedCategory?.code}</div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Description</div>
            <div className='details-value preview-breaks'>
              {selectedCategory?.description ? selectedCategory?.description : '---'}
            </div>
          </div>
          {selectedCategory?.customAttributes &&
            selectedCategory?.customAttributes?.length > 0 &&
            selectedCategory?.customAttributes?.map((item, index) => (
              <div key={index} className='col-md-6 mt-4'>
                <div className='details-label'>{item.key}</div>
                <div className='details-value'>{item.value}</div>
              </div>
            ))}
        </>
      )}
      {tabValue === 1 && (
        <>
          {selectedCategory?.hours?.timings?.length === 1 &&
          selectedCategory?.hours?.timings[0].day === 'EVERYDAY' ? (
            <>
              <div className='row mt-4 mb-2'>
                <div className='col-md-6'>
                  <div className='details-label'>Available On</div>
                  <div className='details-value'>Everyday</div>
                </div>
              </div>
              <div className='row mt-4 mb-2'>
                <div className='col-md-6'>
                  <div className='details-label'>Hours</div>
                  <div className='details-value'>
                    {selectedCategory?.hours?.timings[0].from === ALL_DAY
                      ? '24*7'
                      : changeTimeFormat(
                          selectedCategory?.hours?.timings[0].from,
                          selectedCategory?.hours?.timings[0].to,
                        )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className='row mt-4 mb-2'>
              <div className='col-md-12'>
                <div className='details-label'>Open On</div>
                <div className='details-value'>
                  {selectedDays.map((timing, timeNdx) => (
                    <div className='row' key={timeNdx}>
                      <div className='col-md-12 text'>
                        {renderDays(timing.days)} :{' '}
                        {timing.from === ALL_DAY
                          ? '24*7'
                          : changeTimeFormat(timing.from, timing.to)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {tabValue === 2 && (
        <MediaViewer
          images={selectedCategory.images}
          videos={selectedCategory.videos}
          gifs={selectedCategory.gifs}
          enabledMediaTabs={['image']}
        />
      )}
    </div>
  );
};

export default CategoryViewDetails;
